import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BsArrowDownCircle } from 'react-icons/bs'
import BasicInfo from './project_view/BasicInfo'
import Photo from './project_view/Photo'
import Address from './project_view//Address'

import { BiArrowBack } from 'react-icons/bi'

function ProjectView () {
  const [showCollapse, setShowCollapse] = useState({ tabNo: 0 })
  const location = useLocation()
  const navigate = useNavigate()
  const [item] = useState(location?.state?.item)

  const collapseCheck = tabNo => {
    if (tabNo === showCollapse.tabNo) {
      setShowCollapse({ tabNo: 0 })
    } else {
      setShowCollapse({ tabNo })
    }
  }

  return (
    <>
      <div className='relative pt-6 pl-6 pr-6 pb-6 flex  items-center justify-between border-b-2'>
        <div className='text-base sm:text-lg lg:text-xl font-medium'>
          Project View Details
        </div>
        <div
          className='flex justify-start items-center cursor-pointer mr-2'
          onClick={() => navigate(-1)}
        >
          <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer' />
          <span className='mb-2 ml-2'>Go Back</span>
        </div>
      </div>

      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 1 && 'bg-gray-100'
                } flex  items-center justify-between border-b p-6 cursor-pointer`}
                onClick={() => collapseCheck(1)}
              >
                <div className='text'>Basic Info</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 1 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 1 ? <BasicInfo items={item} /> : null}
              </div>
            </div>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 2 && 'bg-gray-100'
                } flex  items-center justify-between border-b p-6 cursor-pointer`}
                onClick={() => collapseCheck(2)}
              >
                <div className='text'>Address</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 2 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 2 ? <Address items={item} /> : null}
              </div>
            </div>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 3 && 'bg-gray-100'
                } flex cursor-pointer items-center justify-between border-b p-6`}
                onClick={() => collapseCheck(3)}
              >
                <div className='text'>Photos/Videos</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 3 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 3 ? <Photo items={item} /> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProjectView
